<template>
  <div class="main-content">
    <van-nav-bar
      id="titlebar"
      title="请假"
      left-arrow
      @click-right="onClickRight"
      @click-left="onClickLeft"
    >
      <template #right>
        <van-icon name="underway-o" size="18" />
      </template>
    </van-nav-bar>
    <!-- 
      :show-error-message="false"
        @failed="onFailed" -->
    <div class="content">
      <van-form @submit="onSubmit" required error-message-align="right">
        <van-field
          v-model="formData.todoType"
          is-link
          readonly
          name="leaveType"
          label="请假类型"
          input-align="right"
          placeholder="选择请假类型"
          :rules="[{ required: true, message: '请选择请假类型' }]"
          @click="showPicker = true"
        />
        <van-popup v-model:show="showPicker" position="bottom">
          <van-picker
            :columns="typesColumns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>

        <van-field
          v-model="formData.startTime"
          is-link
          readonly
          name="startDate"
          label="开始时间"
          placeholder="选择开始时间"
          input-align="right"
          :rules="[{ required: true, message: '请选择开始时间' }]"
          @click="showStartDatePicker"
        />
        <select-time-view
          ref="startPickerRef"
          @confirm-date="handleStartTime"
        />

        <van-field
          v-model="formData.endTime"
          is-link
          readonly
          name="endDate"
          label="结束时间"
          placeholder="选择结束时间"
          input-align="right"
          :rules="[{ required: true, message: '请选择结束时间' }]"
          @click="showEndDatePicker"
        />
        <select-time-view ref="endPickerRef" @confirm-date="handleEndTime" />

        <van-field
          v-model="duration"
          readonly
          name="leaveHours"
          label="请假时长"
          placeholder="0"
          input-align="right"
        >
          <template #extra>
            <span style="margin-left: 10px">分钟</span>
          </template>
        </van-field>

        <!--  required -->
        <van-field
          v-model="formData.remarks"
          rows="3"
          type="textarea"
          autosize
          name="reason"
          label="请假事由"
          :border="true"
          placeholder="请填写请假事由"
          :rules="[{ required: true, message: '请填写请假事由' }]"
          label-align="top"
        >
          <template #label>
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                justify-content: space-between;
                --van-tag-padding: 8px 15px;
              "
            >
              <span>请假事由</span>
              <van-tag plain type="primary" @click="showSelectRemark"
                >快捷选择事由</van-tag
              >
            </div>
          </template>
        </van-field>
        <selectRemarkView
          ref="remarkRef"
          :leave-type="todoTypeCode"
          @on-select="handleSelectRemart"
        />

        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import selectTimeView from "./selectTimeView.vue";
import selectRemarkView from "./selectRemarkView.vue";
import { submitLeave } from "@/api/leave";
import { closeToast, showLoadingToast, showToast } from "vant";
import moment from "moment";

const router = useRouter();
const initData = {
  // todoType: "1", // 请假类型
  startTime: "",
  endTime: "",
  remarks: "",
};
const formData = reactive({
  todoType: "", // 请假类型
  startTime: "",
  endTime: "",
  remarks: "",
});
// 返回
const onClickLeft = () => {
  window?.flutter_inappwebview?.callHandler("goBackToApp", null);
};
// 请假列表
const onClickRight = () => {
  router.push("/leave/applyList");
};
// 请假事由 快捷选择
const remarkRef = ref();
const showSelectRemark = () => {
  remarkRef.value?.show();
};
const handleSelectRemart = (value) => {
  formData.remarks = value;
};
// 请假类型
const showPicker = ref(false);
// const todoType = ref("");
const todoTypeCode = ref(0);
const typesColumns = [
  { text: "公事", value: "1" },
  { text: "私事", value: "2" },
];
const onConfirm = ({ selectedOptions }) => {
  formData.todoType = selectedOptions[0]?.text;
  todoTypeCode.value = selectedOptions[0]?.value;
  showPicker.value = false;
};

// 开始时间
// const startTime: any = ref("");
// const endTime: any = ref("");
const startPickerRef = ref();
const endPickerRef = ref();
const duration = computed(() => {
  if (formData.startTime.length > 0 && formData.endTime.length > 0) {
    // 使用 Moment.js 解析时间，指定解析格式
    const start = moment(formData.startTime, "YYYY年MM月DD日 HH点mm分");
    const end = moment(formData.endTime, "YYYY年MM月DD日 HH点mm分");
    const diff = end.diff(start, "minute");
    console.log("time", start, end, diff);

    if (diff <= 0) {
      formData.endTime = "";
      showToast("结束时间必须大于开始时间");
      return 0;
    }
    // 计算时间差（单位为小时）
    return diff;
  }
  return 0;
}); //请假时长
const showStartDatePicker = () => {
  startPickerRef.value?.show();
};
const showEndDatePicker = () => {
  endPickerRef.value?.show();
};
const handleStartTime = (times) => {
  formData.startTime = times;
};
const handleEndTime = (times) => {
  formData.endTime = times;
};

// 事由
// const remarks = ref("");

// 表单提交
const onSubmit = (value) => {
  const submitData = { ...value };
  submitData.leaveType = todoTypeCode.value;
  submitData.startDate = moment(
    submitData.startDate,
    "YYYY年MM月DD日 HH点mm分"
  ).format("YYYYMMDDHHmm");
  submitData.endDate = moment(
    submitData.endDate,
    "YYYY年MM月DD日 HH点mm分"
  ).format("YYYYMMDDHHmm");

  showLoadingToast({
    message: "正在提交...",
    forbidClick: true,
  });
  submitLeave(submitData)
    .then(() => {
      // 初始化表单数据
      Object.assign(formData, initData);
      closeToast();
      showSuccessToast("提交成功");
    })
    .catch((error) => {
      closeToast();
      showFailToast(error ?? "提交失败");
    });
};

// const onFailed = (values: object, errors: object[]) => {
//   console.log(values, errors);
// };
</script>
